import { Footer } from "./components/Footer";

export function App() {
  return (
    <div className="min-h-screen bg-gray-50 flex flex-col">
      <main className="flex-1 flex items-center justify-center pb-16">
        <div className="text-center">
          <h1 className="text-5xl font-bold text-gray-900 mb-4">Wooflit</h1>
          <p className="text-xl text-gray-600 mb-8">
            Scheduling for dog trainers and groomers
          </p>
          <div className="inline-block bg-amber-100 text-amber-800 px-6 py-3 rounded-full font-medium">
            Coming soon, woof!
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
